const viewerBackgroundColor = '#e5ddd5';
const viewerDarkBackgroundColor = '#0d1418';

const activeUserBackgroundColor = '#ddf7c8';
const activeUserDarkBackgroundColor = '#0e6162';
const systemBackgroundColor = '#fff5c4';
const systemDarkBackgroundColor = '#353526';

const whatsappThemeColor = '#07bc4c';

const authorColors = [
  '#1f7aec',
  '#fe7c7f',
  '#6bcbef',
  '#fc644b',
  '#35cd96',
  '#e542a3',
  '#91ab01',
  '#ba33dc',
  '#ffa97a',
  '#029d00',
  '#dfb610',
];

export {
  viewerBackgroundColor,
  viewerDarkBackgroundColor,
  systemBackgroundColor,
  systemDarkBackgroundColor,
  activeUserBackgroundColor,
  activeUserDarkBackgroundColor,
  whatsappThemeColor,
  authorColors,
};
